export enum IAccessSharingPermissionType {
  Viewer = 'VIEWER',
  Editor = 'EDITOR',
  Admin = 'ADMIN',
}

export enum IAccessSharingPeriodType {
  Continuous,
  Temporary,
}

export interface IAccessSharingUserData {
  email: string;
  role: IAccessSharingPermissionType;
  period: IAccessSharingPeriodType;
  startsAt?: Date;
  endsAt?: Date;
}
